import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook';
import ContactSocial from './ContactSocial';
import { Box, Divider, Typography } from '@mui/material';
import styled from 'styled-components';
// import { useTheme } from '@mui/material/styles';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import { ReactComponent as Tiktok } from './../../assets/icons/Tiktok.svg'
import { ReactComponent as SnapChat } from './../../assets/icons/SnapChat.svg'
import i18next from 'i18next';


const StyledBox = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 50%;
  border:2px solid #fff;
  transition: transform 0.3s ease, background-color 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
    background-color: #F1C114;
  }

  svg {
    transition: transform 0.3s ease;
     color: #fff;
     fill:#fff;
     width:1.5rem;
     height:1.5rem;
  }

  &:hover svg {
    transform: rotate(-20deg) scale(1.2);
  }
`;
const Social = ({ data }) => {
    let lng = i18next.language
    return (
        <>
            <Box sx={{ position: 'relative', zIndex: 2 }}>
                <Box sx={{ width: 'fit-content', mb: 1, mt: 2 }} >
                    <Typography variant='h6' color={'primary.text'} >{lng === 'en' ? 'Sky Food' : 'سكاي فود'}</Typography>
                    <Divider sx={{ borderWidth: 1, borderColor: '#d9d9d9' }} />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', mt: 2, flexWrap: { md: 'nowrap', xs: 'wrap' }, justifyContent: { md: 'center', xs: 'flex-start' } }}>
                {data?.instagramUrl &&
                    <ContactSocial link={data?.instagramUrl} text={'Instagram Url'}>
                        <StyledBox>
                            <InstagramIcon />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.facebookUrl &&
                    <ContactSocial link={data?.facebookUrl} text={'Facebook Url'} >
                        <StyledBox>
                            <FacebookIcon />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.linkedinUrl &&
                    <ContactSocial link={data?.linkedinUrl} text={"Linkedin Url"} >
                        <StyledBox>
                            <LinkedInIcon />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.snapchatUrl &&
                    <ContactSocial link={data?.snapchatUrl} text={'Snapchat Url'}>
                        <StyledBox>
                            <SnapChat />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.twitterUrl &&
                    <ContactSocial link={data?.twitterUrl} text={'twitter Url'}>
                        <StyledBox>
                            <XIcon />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.tiktokUrl &&
                    <ContactSocial link={data?.tiktokUrl} text={'tiktok Url'}>
                        <StyledBox>
                            <Tiktok />
                        </StyledBox>
                    </ContactSocial>
                }
            </Box>
        </>
    )
}

export default Social